<template>
  <el-dialog :title="!dataForm.id ? '新增' : '修改'"
             :close-on-click-modal="false"
             :visible.sync="visible">
    <el-form :model="dataForm"
             :rules="dataRule"
             ref="dataForm"
             @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="openid"
                    prop="openid">
        <el-input v-model="dataForm.openid"
                  placeholder="openid"></el-input>
      </el-form-item>
      <el-form-item label="联系人"
                    prop="lianxiren">
        <el-input v-model="dataForm.lianxiren"
                  placeholder="联系人"></el-input>
      </el-form-item>
      <el-form-item label="电话"
                    prop="phone">
        <el-input v-model="dataForm.phone"
                  placeholder="电话"></el-input>
      </el-form-item>
      <el-form-item label="公司名称"
                    prop="gsname">
        <el-input v-model="dataForm.gsname"
                  placeholder="公司名称"></el-input>
      </el-form-item>
      <el-form-item label="供货商区域"
                    prop="gonghuoshangquyu">
        <el-input v-model="dataForm.gonghuoshangquyu"
                  placeholder="供货商区域"></el-input>
      </el-form-item>
      <el-form-item label="交货地"
                    prop="jiaohuodi">
        <el-input v-model="dataForm.jiaohuodi"
                  placeholder="交货地"></el-input>
      </el-form-item>
      <el-form-item label="是否含税"
                    prop="ishanshui">
        <el-input v-model="dataForm.ishanshui"
                  placeholder="是否含税"></el-input>
      </el-form-item>
      <el-form-item label="是否含运费"
                    prop="ishanyunfei">
        <el-input v-model="dataForm.ishanyunfei"
                  placeholder="是否含运费"></el-input>
      </el-form-item>
      <el-form-item label="付款方式"
                    prop="paytype">
        <el-input v-model="dataForm.paytype"
                  placeholder="付款方式"></el-input>
      </el-form-item>
      <el-form-item label="预付款比例"
                    prop="yufubili">
        <el-input v-model="dataForm.yufubili"
                  placeholder="预付款比例"></el-input>
      </el-form-item>
      <el-form-item label="交货时间"
                    prop="jiaohuoshijian">
        <el-input v-model="dataForm.jiaohuoshijian"
                  placeholder="交货时间"></el-input>
      </el-form-item>
      <el-form-item label="是否开启保密"
                    prop="isbaomi">
        <el-input v-model="dataForm.isbaomi"
                  placeholder="是否开启保密"></el-input>
      </el-form-item>
      <el-form-item label="审核状态"
                    prop="status">
        <el-input v-model="dataForm.status"
                  placeholder="审核状态"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary"
                 @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: 0,
        openid: '',
        lianxiren: '',
        phone: '',
        gsname: '',
        gonghuoshangquyu: '',
        jiaohuodi: '',
        ishanshui: '',
        ishanyunfei: '',
        paytype: '',
        yufubili: '',
        jiaohuoshijian: '',
        baojiajiezhishijian: '',
        isbaomi: '',
        status: ''
      },
      dataRule: {
        openid: [
          { required: true, message: 'openid不能为空', trigger: 'blur' }
        ],
        lianxiren: [
          { required: true, message: '联系人不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '电话不能为空', trigger: 'blur' }
        ],
        gsname: [
          { required: true, message: '公司名称不能为空', trigger: 'blur' }
        ],
        gonghuoshangquyu: [
          { required: true, message: '供货商区域不能为空', trigger: 'blur' }
        ],
        jiaohuodi: [
          { required: true, message: '交货地不能为空', trigger: 'blur' }
        ],
        ishanshui: [
          { required: true, message: '是否含税不能为空', trigger: 'blur' }
        ],
        ishanyunfei: [
          { required: true, message: '是否含运费不能为空', trigger: 'blur' }
        ],
        paytype: [
          { required: true, message: '付款方式不能为空', trigger: 'blur' }
        ],
        yufubili: [
          { required: true, message: '预付款比例不能为空', trigger: 'blur' }
        ],
        jiaohuoshijian: [
          { required: true, message: '交货时间不能为空', trigger: 'blur' }
        ],
        isbaomi: [
          { required: true, message: '是否开启保密不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '审核状态不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: this.global.apiUrl + `/jxjg/jgcaigouinfo/info/${this.dataForm.id}`,
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            data = data.body
            if (data && data.code === 0) {
              this.dataForm.openid = data.jgcaigouinfo.openid
              this.dataForm.lianxiren = data.jgcaigouinfo.lianxiren
              this.dataForm.phone = data.jgcaigouinfo.phone
              this.dataForm.gsname = data.jgcaigouinfo.gsname
              this.dataForm.gonghuoshangquyu = data.jgcaigouinfo.gonghuoshangquyu
              this.dataForm.jiaohuodi = data.jgcaigouinfo.jiaohuodi
              this.dataForm.ishanshui = data.jgcaigouinfo.ishanshui
              this.dataForm.ishanyunfei = data.jgcaigouinfo.ishanyunfei
              this.dataForm.paytype = data.jgcaigouinfo.paytype
              this.dataForm.yufubili = data.jgcaigouinfo.yufubili
              this.dataForm.jiaohuoshijian = data.jgcaigouinfo.jiaohuoshijian
              this.dataForm.baojiajiezhishijian = data.jgcaigouinfo.baojiajiezhishijian
              this.dataForm.isbaomi = data.jgcaigouinfo.isbaomi
              this.dataForm.status = data.jgcaigouinfo.status
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.global.apiUrl + `/jxjg/jgcaigouinfo/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            params: {
              'id': this.dataForm.id || undefined,
              'openid': this.dataForm.openid,
              'lianxiren': this.dataForm.lianxiren,
              'phone': this.dataForm.phone,
              'gsname': this.dataForm.gsname,
              'gonghuoshangquyu': this.dataForm.gonghuoshangquyu,
              'jiaohuodi': this.dataForm.jiaohuodi,
              'ishanshui': this.dataForm.ishanshui,
              'ishanyunfei': this.dataForm.ishanyunfei,
              'paytype': this.dataForm.paytype,
              'yufubili': this.dataForm.yufubili,
              'jiaohuoshijian': this.dataForm.jiaohuoshijian,
              'isbaomi': this.dataForm.isbaomi,
              'status': this.dataForm.status
            }
          }).then((data) => {
            data = data.body
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/jgcaigouinfo-add-or-update.vue